module.exports = __webpack_public_path__ + "static/media/bd_ttl_yobou.ca077b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bd_ttl_yobou.png
// module id = 1624
// module chunks = 1